import React from 'react';
import AppHeader from '../components/AppHeader';
import { useLanguage } from '../i18n';

const PrivacyPolicyPage: React.FC = () => {
  const { dir, t } = useLanguage();

  return (
    <div className="min-h-screen bg-black text-gray-200" dir={dir}>
      <AppHeader />
      <main className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <header className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{t('pages.privacy.title')}</h1>
          <p className="text-gray-400">{t('pages.privacy.effectiveDate', { date: new Date().toLocaleDateString('en-US') })}</p>
        </header>

        <section className="space-y-6 text-lg leading-relaxed">
          <p>{t('pages.privacy.intro')}</p>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.dataCollection.title')}</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>{t('pages.privacy.sections.dataCollection.registration')}</li>
              <li>{t('pages.privacy.sections.dataCollection.billing')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.aiUsage.title')}</h2>
            <p>{t('pages.privacy.sections.aiUsage.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.dataUse.title')}</h2>
            <p>{t('pages.privacy.sections.dataUse.intro')}</p>
            <ul className="list-disc list-inside space-y-2">
              <li>{t('pages.privacy.sections.dataUse.items.deliver')}</li>
              <li>{t('pages.privacy.sections.dataUse.items.billing')}</li>
              <li>{t('pages.privacy.sections.dataUse.items.support')}</li>
              <li>{t('pages.privacy.sections.dataUse.items.improve')}</li>
              <li>{t('pages.privacy.sections.dataUse.items.communicate')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.retention.title')}</h2>
            <p>{t('pages.privacy.sections.retention.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.sharing.title')}</h2>
            <p>{t('pages.privacy.sections.sharing.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.security.title')}</h2>
            <p>{t('pages.privacy.sections.security.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.rights.title')}</h2>
            <p>{t('pages.privacy.sections.rights.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.changes.title')}</h2>
            <p>{t('pages.privacy.sections.changes.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mt-10 mb-3">{t('pages.privacy.sections.contact.title')}</h2>
            <p>{t('pages.privacy.sections.contact.content')}</p>
          </section>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;

